/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";
console.log('JS loaded');

document.addEventListener('DOMContentLoaded', function () {
    console.log('Init Scripts');

    let submitBtn = document.querySelectorAll('#rex-yform button[type=submit]');
    if (submitBtn) {
        submitBtn.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                evt.target.classList.add('activated');
            });
        });

    }
});

